var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805H5.99609C5.46566 1.99805 4.95695 2.20876 4.58188 2.58383C4.20681 2.95891 3.99609 3.46761 3.99609 3.99805V19.998C3.99609 20.5285 4.20681 21.0372 4.58188 21.4123C4.95695 21.7873 5.46566 21.998 5.99609 21.998H17.9961C18.5265 21.998 19.0352 21.7873 19.4103 21.4123C19.7854 21.0372 19.9961 20.5285 19.9961 19.998V8.99805L12.9961 1.99805Z",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805V8.99805H19.9961",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#7755FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.564 22V16.584H5.588V15.52H8.972V16.584H8.004V22H6.564ZM11.7425 22.096C11.3372 22.096 10.9985 22.024 10.7265 21.88C10.4545 21.736 10.2492 21.5147 10.1105 21.216C9.97183 20.912 9.8945 20.52 9.8785 20.04L11.1025 19.856C11.1078 20.1333 11.1318 20.3573 11.1745 20.528C11.2225 20.6987 11.2865 20.8213 11.3665 20.896C11.4518 20.9707 11.5532 21.008 11.6705 21.008C11.8198 21.008 11.9158 20.9573 11.9585 20.856C12.0065 20.7547 12.0305 20.648 12.0305 20.536C12.0305 20.2693 11.9665 20.0453 11.8385 19.864C11.7105 19.6773 11.5372 19.4907 11.3185 19.304L10.7585 18.816C10.5132 18.608 10.3052 18.3733 10.1345 18.112C9.96917 17.8453 9.8865 17.5173 9.8865 17.128C9.8865 16.5787 10.0492 16.16 10.3745 15.872C10.6998 15.5787 11.1425 15.432 11.7025 15.432C12.0492 15.432 12.3265 15.4907 12.5345 15.608C12.7478 15.7253 12.9078 15.88 13.0145 16.072C13.1265 16.2587 13.2012 16.4587 13.2385 16.672C13.2812 16.88 13.3052 17.08 13.3105 17.272L12.0785 17.424C12.0732 17.232 12.0598 17.0667 12.0385 16.928C12.0225 16.784 11.9852 16.6747 11.9265 16.6C11.8678 16.52 11.7772 16.48 11.6545 16.48C11.5212 16.48 11.4225 16.536 11.3585 16.648C11.2998 16.76 11.2705 16.872 11.2705 16.984C11.2705 17.224 11.3265 17.4213 11.4385 17.576C11.5558 17.7253 11.7078 17.8827 11.8945 18.048L12.4305 18.52C12.7132 18.76 12.9505 19.032 13.1425 19.336C13.3398 19.64 13.4385 20.016 13.4385 20.464C13.4385 20.768 13.3692 21.0453 13.2305 21.296C13.0918 21.5413 12.8945 21.736 12.6385 21.88C12.3878 22.024 12.0892 22.096 11.7425 22.096ZM15.4134 22L14.2454 15.52H15.4694L16.1654 19.92L16.8134 15.52H18.1094L16.9254 22H15.4134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsv);
export default __webpack_public_path__ + "static/media/tsv.b14dd03c79510f95e916a7c990e3dffb.svg";
export { ForwardRef as ReactComponent };